import {
  Box,
  Text,
  Flex,
  Spacer,
  HStack,
  useTheme,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import SearchBox from "../../../components/searchbox/SearchBox";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import CustomTable from "../../../components/table/customTable/CustomTable";
import AddSubTopicModal from "../../../components/modals/AddModals/AddSubTopicModal";
import { useDisclosure } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getAllSubtopics } from "../../../store/slice/subtopicSlice";
const SubTopic = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { subtopics, status } = useSelector((state) => state.subtopics);
  const { primaryBlue } = theme.colors.pallete;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const extraColumns = [
    { label: "Chapter", key: "chapter" },
    { label: "Topic", key: "topic" },
  ];

  useEffect(() => {
    dispatch(getAllSubtopics());
  }, []);
  return (
    <Box w={"100%"}>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Sub Topic
        </Text>
        <Spacer />
        <CourseTextButton text={"Add Sub Topic"} onClick={onOpen} />
      </Flex>
      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit />
        </HStack>

        <Spacer />

        <SearchBox />
      </Flex>
      {status === "loading" ? (
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Spinner size="md" color="blue.500" />
        </Box>
      ) : status === "failed" ? (
        <Text>No Subtopics</Text>
      ) : (
        <CustomTable data={subtopics} entityType="chapter"  />
      )}

      <AddSubTopicModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};

export default SubTopic;
